import React, { useState, useRef } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { ContentfulLogo } from "wmk-lib";
import { Container, Row, Col } from "react-bootstrap";
import TopBar from "./TopBar";
import Search from "./Search/Search";
import Hamburger from "./Hamburger/Hamburger";
import { WMKLink } from "wmk-lib";
import { FaPhone } from "react-icons/fa";
import Theme from "../../../vars/ThemeOptions";
import styled from "styled-components";
import HamburgerDrawer from "./Hamburger/HamburgerDrawer";
import { scrubTitle } from "../../../pages/sitemap";

const IconWrap = styled(Col)`
  &.call {
    svg {
      position: relative;
      @media screen and (max-width: ${Theme.break.md}px) {
        top: 3px;
      }
    }
    span {
      margin-top: 9px;
    }
  }
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  overflowx: hidden;
  padding: 2vw;
  .wmk-link {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .wmk-link,
  button {
    appearance: none;
    border: none;
    background: none;
    color: black;
    @media only screen {
      :focus {
        outline: none;
      }
    }
    :hover {
      color: ${Theme.hex("green")};
    }
  }
  span {
    font-size: 0.75rem;
    text-transform: uppercase;
    display: block;
    font-weight: 600;
  }
`;

const MainMenu = ({
  winWidth,
  isSearchOpen,
  setIsSearchOpen,
  pageType,
  slug,
  parentChapter,
  setTopBarHeight,
}) => {
  const [isBurgerOpen, setIsBurgerOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const data = useStaticQuery(graphql`
    {
      options: contentfulGlobal(title: { eq: "Footer: Texas Health" }) {
        ...NodeGlobalFields
      }
      hamburgerPages: contentfulMenus(title: { eq: "Hamburger: Pages" }) {
        ...NodeMenuFields
      }
      pages: allContentfulPages {
        edges {
          node {
            title
            slug
          }
        }
      }
      chapters: allContentfulChapters(
        filter: { title: { regex: "/2020: /" } }
      ) {
        edges {
          node {
            title
            slug
          }
        }
      }
      topics: allContentfulTopics {
        edges {
          node {
            title
            slug
            chapter
            modules {
              ... on ContentfulModuleBodyCopy {
                ...ModuleBodyCopyFields
              }
              ... on ContentfulModuleSnapshot {
                ...ModuleSnapshotFields
              }
            }
          }
        }
      }
    }
  `);
  const {
    options,
    pages,
    //chapters,
    topics,
    hamburgerPages,
  } = data;
  const chapters = {
    edges: data.chapters.edges.map((e) => {
      return { node: { ...e.node, title: scrubTitle(e.node.title) } };
    }),
  };
  const headerRef = useRef();
  const { links } = options;
  const linkTop = links[0];
  const isMobile = winWidth < Theme.break.md;
  return (
    <>
      <Container
        fluid
        style={{
          margin: 0,
          padding: "0",
          boxShadow: "2px 4px 6px rgba(0,0,0,.125)",
        }}
        ref={headerRef}
      >
        <TopBar topLink={linkTop} setTopBarHeight={setTopBarHeight} />
        <Container>
          <Row
            style={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <Col
              className="logo-wrap"
              style={{
                paddingLeft: "2vh",
                paddingRight: "2vh",
                maxWidth: isMobile ? "160px" : "300px",
              }}
            >
              <ContentfulLogo
                url={options.logo.file.url}
                contentType={options.logo.file.contentType}
                alt={options.logo.title}
              />
            </Col>
            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <Row>
                <IconWrap xs="auto">
                  <Search
                    isMobile={isMobile}
                    isSearchOpen={isSearchOpen}
                    setIsSearchOpen={setIsSearchOpen}
                    query={{ pages, chapters, topics }}
                  />
                </IconWrap>
                <IconWrap xs="auto" className="call">
                  <WMKLink to={"tel:" + options.phone} target={"tel"}>
                    <FaPhone />
                    {isMobile ? <span>{"Call"}</span> : null}
                  </WMKLink>
                </IconWrap>
                <IconWrap xs="auto">
                  <Hamburger
                    isMobile={isMobile}
                    isBurgerOpen={isBurgerOpen}
                    setIsBurgerOpen={setIsBurgerOpen}
                    setHeaderHeight={setHeaderHeight}
                    headerRef={headerRef}
                  />
                </IconWrap>
              </Row>
            </Col>
          </Row>
        </Container>
      </Container>
      <HamburgerDrawer
        isBurgerOpen={isBurgerOpen}
        headerHeight={headerHeight}
        query={{
          pages: {
            edges: hamburgerPages.menuItems.map((mi) => {
              return { node: mi };
            }),
          },
          chapters,
          topics,
        }}
        pageType={pageType}
        slug={slug}
        parentChapter={parentChapter}
      />
    </>
  );
};

export default MainMenu;
